import {AsyncValue} from '@kensho/tacklebox'

import useBaseFetch from '../hooks/useBaseFetch'
import {UsageRecord} from '../types/types'

// response shape when we provide a page / page_size
export interface PaginatedUsageResponse {
  count: number
  next: string
  previous: string
  results: UsageRecord[]
}

// response shape when page / page_size aren't provided
export interface UnpaginatedUsageResponse {
  count: number
  amountSum: number
}

// Use a conditional type to indicate the response type based on the shape of the provided options
type ResponseType<T> = T extends PaginatedOptions
  ? PaginatedUsageResponse
  : T extends UnpaginatedOptions
    ? UnpaginatedUsageResponse
    : never

interface SharedUsageRecordOptions {
  stripePriceId?: string
  startTimestamp?: string
  endTimestamp?: string
  charged: boolean
}

interface PaginatedOptions extends SharedUsageRecordOptions {
  page: number
  pageSize: number
}

interface UnpaginatedOptions extends SharedUsageRecordOptions {
  page?: void
  pageSize?: void
}

type RequestType = PaginatedOptions | UnpaginatedOptions

/**
 * Fetch the usage history for this user's APIs
 */
export default function useUsage<T extends RequestType>(params: T): AsyncValue<ResponseType<T>> {
  return useBaseFetch<T, ResponseType<T>>('/api/v1/usage/', params, undefined)
}
